import request from '@/utils/request'
import {applicationName} from '@/utils/const.js'

export function insert(data){
  return request({
    url:applicationName+'/admin/brandInformation',
    method:'POST',
    headers:{
      "Content-Type":"application/json;charset=utf-8"
    },
    data:JSON.stringify(data)
  })
}

export function deleted(data){
  return request({
    url:applicationName+'/admin/brandInformation',
    method:'delete',
    headers:{
      "Content-Type":"application/json;charset=utf-8"
    },
    data:JSON.stringify(data)
  })
}

export function deletedIds(ids,data){
  return request({
    url:applicationName+'/admin/brandInformation/ids',
    method:'delete',
    headers:{
      "Content-Type":"application/json;charset=utf-8"
    },
    params:data,
    data:JSON.stringify(ids)
  })
}

export function query(data){
  return request({
    url:applicationName+'/admin/brandInformation',
    method:'get',
    params:data
  })
}

export function queryList(data){
  return request({
    url:applicationName+'/admin/brandInformation/list',
    method:'get',
    params:data
  })
}

export function update(data){
  return request({
    url:applicationName+'/admin/brandInformation',
    method:'put',
    headers:{
      "Content-Type":"application/json;charset=utf-8"
    },
    data:JSON.stringify(data)
  })
}

export function insertBackImg(data){
  return request({
    url:applicationName+'/admin/brandInformation/backImg',
    method:'POST',
    headers:{
      "Content-Type":"application/json;charset=utf-8"
    },
    data:JSON.stringify(data)
  })
}

export function queryBackImg(){
  return request({
    url:applicationName+'/admin/brandInformation/backImg',
    method:'get'
  })
}